import { validateCtc } from "../../../../utils/ctc";

const validate = (name,value,formData)=>{
    let error = {status:false,message:''}
    let isField = schema[name];
    const mobileNumber = formData[name];
    const mobileNumberPattern = /^\+?[0-9]+$/;



    const fieldNames = {
        FirstName:'First Name',
        LastName:'Last Name',
        Gender:'Gender',
        EmailID:'Email ID',
        DateOfBirth:'Date Of Birth',
        MobileNo:'Contact No',
        CurrentPosition:'Designation',
        ReferralID:'Source',
        job_title:'Skill Set',
        AppliedDate:'Applied Date',
        hr:'Hr Name',
        job_title:'Job Title',
        SkillSet:'Skill Set',
        CurrentCTC: 'Current CTC',
        ExpectedCTC: 'Expected CTC',
        NoticePeriod: 'Notice Period'
    };
    if(isField){
        let validation = isField;
        for(let i=0;i<validation.length;i++){
            switch(validation[i]){
                case 'required':
                if(formData[name]==''){
                    error = {status:true,message:`${fieldNames[name]} is required`};
                    return error;
                }
                break;
                case 'mobile':
                    if(!mobileNumberPattern.test(mobileNumber)){
                        error = {status:true,message:`Valid mobile No. required`};
                        return error;
                    }
                break;   
                // case 'select':
                //     if(formData[name]?.value==''){
                //         error = {status:true,message:`This field is required`};
                //         return error;
                //     }
                // break;
                case 'select':
                    if (!formData[name]?.value || formData[name]?.value === '') {
                      error = { status: true, message: `${fieldNames[name]} is required` };
                      return error;
                    }
                    break;
                case 'ctc':
                    error = validateCtc(formData[name],fieldNames[name]);
                    if(error.status){
                        return error;
                    }
                    break;
            }
        }
    }
    return error;
}
const schema = {
    FirstName:['required'],
    LastName:['required'],
    Gender:['required', 'select'],
    EmailID:['required'],
    DateOfBirth:['required'],
    MobileNo:['required','mobile'],
    CurrentPosition:['required'],
    ReferralID:['required'],
    job_title:['required', 'select'],
    AppliedDate:['required'],
    // hr:['required'],
    hr: ['required', 'select'],
    SkillSet:['required'],
    CurrentCTC: ['required','ctc'],
    ExpectedCTC: ['required','ctc'],
    NoticePeriod: ['required', 'select']
    // ReferralID:['select']
}
export default validate;
